import { apiClient } from "./client.api";
import { CourseCatalogData } from "../../types/course.response";

/** 后端确认的单次 batch key 数上限(契约 §5.2-4) */
const BATCH_KEY_LIMIT = 200;

export const coursesApi = {
    /**
     * 批量拉取课程展示数据(POST /courses/batch,契约 §5)。
     * keys 一律取自 skeleton courses 字典的 key(CourseSummary.mapKey),前端从不手工构造。
     * 超过上限自动分批,结果合并返回;响应中缺失的 key 表示该课已不存在(结构漂移)。
     */
    getBatch: async (keys: string[]): Promise<Record<string, CourseCatalogData>> => {
        const chunks: string[][] = [];
        for (let i = 0; i < keys.length; i += BATCH_KEY_LIMIT) {
            chunks.push(keys.slice(i, i + BATCH_KEY_LIMIT));
        }
        const results = await Promise.all(
            chunks.map(chunk => apiClient.post(`/courses/batch`, { keys: chunk }))
        );
        const merged: Record<string, CourseCatalogData> = {};
        for (const response of results) {
            Object.assign(merged, response.data.data.courses);
        }
        return merged;
    },
};
